import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ExtractorSemaphoresRoute } from '../../routing'

export class ExtractorSemaphoresPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <ExtractorSemaphoresRoute />
            </Fragment>
        )
    }
}
